export default {
  // 导航
  app_nav: {
    businessManage: 'System management',
    membersManage: 'Members management',
    roleManage: 'Role management',
    customApp: 'Custom application',
    safeManage: 'Safety management',
    interfaceIntegratio: 'Interface integration',
    appCenter: 'Application center',
    recycleBin: 'Recycle bin',
    personalSetting: 'Personal setting',
    platformTemplate: 'Platform template',
    noAuth: 'No authority to do this',
    accountCenter: 'Account center',
    applicationManagement: 'Application management',
    dataCenter: 'Data center',
    taskMonitoring: 'Automated task monitoring',
    systemTemplate: 'System template'
  },
  // 企业管理
  business_management: {
    manageHomepage: 'Manage home page',
    basicmodule: 'Basic module',
    businessManage: 'Business management',
    businessSet: 'Business setting',
    businessWorkflow: 'Business workflow',
    welcome: 'Welcome,  you are at',
    managebackstage: 'Management backstage',
    currentVersion: 'Current version',
    versionInfo: 'Version information',
    closingDate: 'Deadline',
    systemVersion: 'System version',
    accountUsage: 'Account usage',
    accountNum: 'Account number',
    spaceUsage: 'Space usage',
    space: 'Space',
    dataUsage: 'Data usage',
    dataNum: 'Data number',
    modifyEnterpriseName: 'Modify the organization name',
    modifyEnterpriseTip:
      'After modifying the name of the current organization, all the name will be replaced by the new name。Recommended not to change the name of the organization frequently, so that the enterprise members do not recognize the organization properly.',
    modifyEnterpriseAdress: 'Modify organization adress',
    modifyEnterpriseTip2:
      'After modifying the current address of the business, all addresses on the personal business card will be replaced by the new addresses, and different departments can use different business addresses.',
    addAddress: 'Continue adding the business address',
    continueaddAddress: 'Continue to add the business address',
    editentErpriseLogo: 'Edit the platform logo',
    logoTip:
      'Suggested to upload transparent bottomless white paper PNG logo, 240 x 70 size PNG image; image size no more than 1M',
    updateLogo: 'Upload logo',
    modifylocalDomainAddress: 'Modify the localized domain address',
    localDomainAddress: 'Local domain address',
    domainAddressTip:
      'Modify the localized domain name address for establishing links with the certification platform to ensure that enterprises can use this system normally.',
    domainAddressTip2:
      'Please enter the Huashengke domain name or public IP (containing port and required)',
    modifylocalIMaddress: 'Local IM Address',
    localIMaddress: 'local IM address',
    imAddressTip: 'Im addresses can be modified for the use of corporate letters.',
    imAddressTip2: 'For IM use, please enter the correct IP address.',
    appBannerSet: 'mobile Banner setting',
    updateTip:
      'Suggested to upload JPG format images, 1035 x 420 size PNG images, up to 5 uploads;    No more than 1M per image;',
    updateBanner: 'update Banner',
    languageSelect: 'language select',
    setLanguageType: 'set the language type of the enterprise',
    chinese: 'Chinese',
    traditional: 'Chinese Traditional',
    english: 'English',
    transferEnterprise: 'Change Owner',
    transferEnterpriseTip:
      'If you no longer want to manage your current platform/organization, you can choose to transfer to another business member of the organization, after which you will not be able to manage the current platform/organization, and the operation cannot be revoked.',
    selectOwner: 'Select the platform owner',
    loginPwd: 'login password',
    inputCurrentPwd: 'input the current password',
    enterpriseName: 'the name of organization',
    enterpriseName_empty: 'the organization name can not be empty',
    domain_empty: 'the domain name address cannot be empty',
    adress_error: 'the address format is incorrect',
    maxImages5: 'maximum upload up to 5 pictures',
    image_empty: 'please upload pictures',
    imageSize: 'No more than 1M per image',
    owner_empty: 'Platform owner cannot be empty',
    imageFormat: 'Please upload a picture of PNG or JPG',
    imageLimit: 'Images exceed upload limits',
    inputAddress: 'Please enter the business address',
    pleaseSelectDepartment: 'please select department',
    departmentalDuplication: 'Department repeat，please choose again',
    billManage: 'bill management',
    SMSManage: 'SMS management',
    addWorkflow: 'add workflow',
    userMember: 'user member',
    workflowName: 'workflow name',
    addMember: 'add member',
    workflowDesc: 'workflow description',
    inputContent1000: 'Please enter the content, no more than 1000 words',
    inputWorkflowName25: 'Please enter the workflow name, no more than 25 words',
    workflowNameNotEmpty: 'workflow name cannot be empty ',
    sureDelWorkflow: 'Are you sure you want to delete the workflow?',
    addContion: 'add condition',
    resetWorkflowDelInfo:
      'After the reset, the process reverts to the initialization style, and the set workflow is restored. Are you sure you want to reset it?',
    accountBinding: 'account binding',
    sendManage: 'sending management',
    signtrue: 'signature',
    accountBindingMsg1:
      'Before using SMS, register your account on the corresponding SMS platform .After registration, enter AppKey and Master Secret to the system for binding.',
    accountBindingMsg2: 'SMS platform',
    accountBindingMsg3: 'Sending SMS status callback',
    accountBindingMsg4:
      'To get the reason for the failure when the approval fails, copy the URL to the "Downstream Message Send Status Callback Settings" in the 【SMS Settings】 of the Aurora system',
    accountBindingMsg5: 'template approval ctatus callback',
    accountBindingMsg6:
      'To get the reason for the failure when the approval fails, copy the URL to the "Template Review Results Callback" in the 【SMS Settings】 of the Aurora System',
    accountBindingMsg7: 'Template approval Status Callback',
    accountBindingMsg8:
      'To get the reason for the failure when the approval fails, copy the URL to the Signature Review Results Callback in the 【SMS Settings】 of the Aurora system',
    accountBindingMsg9:
      'you can find it in the【Application Settings】-【Application Information】',
    AppKeyNotEmpty: 'AppKey cannot be empty',
    MasterNotEmpty: 'Master Secret cannot be empty',
    sendContent: 'sending cotent',
    downAll: 'download all',
    failReason: 'failure reason',
    sending: 'sending',
    sendSuccess: 'send successfully',
    sendFail: 'sending failed',
    sendStatus: 'sending status',
    sendCount: 'sending number',
    receiveMunber: 'receiving number',
    sendTiem: 'sending time',
    allInfo: 'all information',
    signtrueName: 'signtrue name',
    signtrueType: 'signtrue type',
    documentaryEvidence: 'Supporting documents',
    documentaryEvidenceInfo: 'Files support PNG, JPG, JPEG formats and no larger than 2M',
    name: 'name',
    nameInfo: '2-8 characters of length, no need to add【】',
    uploadFile: 'upload file',
    signtrueTypeInfo1: 'Organization full name or short name',
    signtrueTypeInfo2: 'Business license required',
    signtrueTypeInfo3:
      'The full name or abbreviation of the website filed by the Ministry of Industry and Information Technology',
    signtrueTypeInfo4: "The sponsor's business license is required",
    signtrueTypeInfo5: 'The full name or abbreviation of the application',
    signtrueTypeInfo6:
      "Download links to any app store and developer's business license are required",
    signtrueTypeInfo7: 'Full name or abbreviation of the name of the subscription or program',
    signtrueTypeInfo8: 'subject business license of the subscription or program required',
    signtrueTypeInfo9: 'Full name or abbreviation of the name of E-commerce platform store',
    signtrueTypeInfo11: 'Full name or abbreviation of the name of trademark',
    signtrueTypeInfo12: 'trademark registration certificate is required',
    signtrueTypeInfo13: 'others',
    signtrueTypeInfo14: "Owner's business license is required",
    signtrueTypeInfo15: 'Please briefly describe your business scenario, no more than 100 words',
    nameMustfill: 'Name required',
    documentaryFlieNotEmpty: 'Supporting documents cannot be empty',
    applicationNotesMustfill: 'Application Description is required',
    sureDelFigntrue: 'Are you sure you want to delete the signature?',
    determineDelete:
      'There is a SMS template under this signature, please confirm that the signature is without template used',
    picMax2M: 'image size no larger than 2MB',
    onlineApproval: 'approval online, efficient and direct',
    approvalType: 'approval type',
    dataQuery: 'data query',
    startPer: 'originator',
    query: 'query',
    ModifyCurrentApprover: 'Modify current approver',
    currentApproverModufy: 'Change the current approver to the designated person',
    projectInfo:
      'Visual organizational tools can help you manage and monitor project development faster and more accurately',

    upgrade: 'upgrade',
    additional: 'Additional purchase',
    remainingavailable: 'Remaining available',
    purchasedusersnumber: 'Authorized number of users',
    usedusersnumber: 'Number of users used',
    remainingdays: 'Days Remaining',
    starttime: 'start time',
    endtime: 'End time',
    totaldataavailable: 'Total data available',
    totalamountdataused: 'Total data used',
    totalattachmentspace: 'Total attachment space',
    attachmentspaceused: 'Used attachment space',
    cleardeletedfiles: 'One click to clear deleted files',
    consumptionsituation: 'Consumption',
    applyforinvoice: 'Apply for invoice',
    contractinformationperfect: 'Improvement of contract information',
    typeofbusiness: 'Business type',
    ordernumber: 'order number',
    orderstatus: 'Order status',
    tobepaid: 'To be paid',
    paymentsuccessful: 'Payment successful',
    cancelorder: 'cancellation of order',
    paymenttime: 'Payment time',
    orderamount: 'Order amount',
    paymenttype: 'Payment type',
    wechat: 'WeChat',
    alipay: 'Alipay',
    contractdownload: 'Contract Download',
    organizeinformation: 'Organization information',
    fullorganizationname: 'Full name of organization',
    organizespecificaddress: 'Specific address of organization',
    zipcode: 'Postal Code',
    emailaddress: 'mail box',
    contactname: 'Contact name',
    mobilenumber: 'phone number',
    fax: 'Fax',
    additionalorders: 'Additional purchase order',
    additionalpurchasetype: 'Type of additional purchase',
    increaseaccountnumber: 'Increase the number of accounts',
    companyname: 'corporate name',
    contractpreview: 'Contract Preview',
    continuelongtime: 'Renewal duration',
    durationofuse: 'Duration of use',
    expandedquantity: 'Expanded quantity',
    numberofpackages: 'Number of packages',
    expansionspace: 'Extended space',
    paymentamount: 'Payment amount',
    companypackageendtime: 'End time of organization package',
    paymentamountcalculate:
      'Payment amount = (end time of package - time of day) * unit price of contract account',
    methodofpayment: 'Payment method',
    paynow: 'Immediate payment',
    payTip1:
      'After receiving the payment, the system automatically generates the renewal order and completes the renewal service.',
    payTip2: 'If you have completed the payment and failed to renew, please call the free hotline',
    teamfacecashier: 'Cash register',
    scanpayment: 'Payment by scanning (RMB)',
    turnonphonewechat: 'Open mobile wechat',
    scancompletepayment: 'Scan to complete payment',
    pay: 'payment',
    completepayment: 'Complete payment',
    youcanchoose: 'You can choose',
    gototheadminhomepagetoviewconsumption: 'Check the consumption on the Management Homepage',
    paymentfailed: 'Payment failed',
    suggestyouselect: 'It is recommended that you choose',
    reorderpayment: 'Re order payment',
    renewal: 'renew',
    expansionseat: 'Expansion of seats',
    expandeddataaggregate: 'Expand the total amount of data',
    expandeddata: 'Extended data',
    totaldatacharge: 'Total data',
    expandedseats: 'Expansion of seats',
    upgradedversion: 'Upgrade version',
    order_amount_error: 'Abnormal order amount',
    company_full_name_error: 'Full name of organization cannot be empty',
    company_address_error: 'Organization specific address cannot be empty',
    email_empty: 'Email cannot be empty',
    email_error: 'Email format error',
    contact_name_error: 'Contact name cannot be empty',
    enterpriseAdress: 'Business address',
    binding: 'binding',
    customLogin: 'Custom login settings',
    customLoginTip:
      'Customers can define the login mode, logo, style and address according to their own personalized needs.',
    enableCustomLogin: 'Enable custom login design',
    loginAddress: 'Exclusive login address',
    loginAddress1: 'Please enter (at least 6 digits, start with a letter)',
    corporateShowcase: 'Platform logo',
    imagesTip: 'Support JPG, GIF, PNG format, no more than 5m pictures',
    leftImage: 'Login side map',
    uploadPicture: 'Upload pictures',
    reset: 'Reset',
    pictureSuggestedSize: 'Suggested size of picture',
    pageBackground: 'Page background',
    backgroundColor: 'background color',
    backgroundPicture: 'Background image',
    fontColor: 'Font color',
    loginMethod: 'Login method',
    automaticLoginOptions: 'Auto login options',
    check: 'Check',
    donotcheck: 'Do not check',
    hide: 'hide',
    display: 'display',
    registrationEntry: 'Registration entrance',
    visitWebsite: 'Visit the official website',
    websiteTip: "You can enter the organization's official website address",
    website_empty: 'Visit official website cannot be empty',
    weChatNote:
      "Operation: set the bottom link address in the official account menu. (Note: WeChat needs localizing the customer's address. Port must use 80 or 443 ports, otherwise WeChat official account can not be accessed through the address. )",
    weChatPublicAccess: 'WeChat official account',
    weChatPublicAccount: 'WeChat official account',
    weChatPublicAccountContent: 'Customize the module directly through WeChat official account.',
    weChatPublicAccountName: 'WeChat official account name',
    pushModule: 'Push module',
    setTemplateID1: 'WeChat official account message push settings',
    setTemplateID2:
      'Through the official account official of WeChat, the system will support the push of the message to WeChat official account, without filling and marking, and no push message to WeChat official account.',
    setTemplateID3: 'WeChat official account template ID',
    setTemplateID4:
      'Enter WeChat official account backstage > function > add function plugin to apply template message function. After approval, you can get module ID in the list.',
    loginFreeSettings: 'Login free settings',
    loginFreeSettingsNote:
      'Enter the background of WeChat official account, and input the corresponding content of WeChat official account to the system, so that no login can be realized.',
    nailingLink:
      'Path: nailing development platform > Application Development > H5 micro Application > application details - application information',
    nailingLink2: 'Path: nail development platform > Application Development > login',
    nailingLink3:
      'Nail development platform > basic information > development information (old version) - > enterprise self use account information',
    autonomousApplication: 'Nailing or enterprise wechat - independent application settings',
    autonomousApplicationTip:
      'After setting, localized customers can use it in nailing or enterprise wechat. Before setting, please apply for uploading independent H5 wechat application in nailing or enterprise wechat.',
    nailing: 'Nail',
    enterpriseweChat: 'Enterprise wechat',
    scanLogin: 'Scan code login configuration',
    weChatjsUrl:
      'Enter the background of WeChat public official account > right top corner head > function Settings > function settings > JS interface security domain name line click Settings > download files in pop-up (file 3 in file)',

    weChatjsFile: 'JS interface security domain name file',
    weChatjsFile_error: 'JS interface security domain name file only supports TXT text file',

    localdomainaddresssetting: 'Local domain name address settings',
    solidcolor: 'Solid color',
    publicqrcodereplacement: 'Official account for two-dimensional code replacement',
    uploadcompanyqrcodesofficialaccount:
      "Upload the organization's official account number two dimensional code.",
    title: 'title',
    qrcode: 'QR code',
    uploadqrcodepicture: 'Upload QR code image',
    publishapplication: 'Publish application',
    webaddress: 'Web address',
    pcsidebackgroundconfiguration: 'PC end background configuration',
    receivingserveraddress: 'Receiving server address',
    enterpriseloginaddress_empty: 'Exclusive login address cannot be empty',
    enterpriseloginaddress_error: 'Exclusive login address can only exist in English and letters',
    bindingnailingconfirm: 'Are you sure you want to rebind the nails?',
    bindingweChatconfirm: 'Are you sure you want to rebind enterprise wechat?',
    enterpriseloginaddress_error2: 'Exclusive login address conflict',
    companyNumber: 'Organization number',
    // 20201224
    enterprisedisplaychart: 'Background Display Image',
    // 20210305
    usercertificate: 'Use certificate',
    certificate: 'Certificate of Authorization',
    cloud: 'Cloud service',
    local: 'Local',
    upgradeTip: 'To use this function, you need to upgrade to a higher version',
    upgradeAlert: 'Upgrade reminder',
    upgradeTip2: 'Dear customer, To use this function, you need to upgrade to a higher version',
    enquiryHotline: 'Consultation hotline',
    scanningconsulting: 'Scan QRcode to get consultation for upgrade service',
    openconnection: 'Open link',
    submitupgraderequestonli: 'Submit upgrade requirements online',
    pgradeNow: 'Upgrade immediately',
    versionUpgrade: 'Version upgrade',
    selectversion: 'Choose a version',
    fit: 'fit',
    customEdition: 'tailor-made',
    customExclusiveVersion: 'tailor-made version according to the needs',
    payasyouwant: 'Pay-as-you-go',
    onDemand: 'On-demand customization',
    applynow: 'apply now',
    renewalOrder: 'Renewal order',
    renewalPeriod: 'Renewal period',
    upgradedVersionOnly: 'No renewal, upgrade version only',
    singleTotal: 'Total',
    accounerror:
      'Please increase the number of accounts before upgrading the version if the number of accounts is lower than the minimum requirements',
    upgradeto: 'upgrade to'
  },
  // 成员管理
  membership_management: {
    department: 'department',
    seachall: 'Search for name, account number, mobile phone number',
    disabledEmployee: 'disabled employee',
    jobManage: 'job management',
    personCharge: 'head',
    searchResult: 'the searching result of',
    addStaff: 'add employee',
    updateStaff: 'upload employee',
    adjustDepartment: 'adjust department',
    changeRole: 'change role',
    addRoles: 'add roles',
    resetPwd: 'reset password',
    activationReminder: 'activation reminder',
    addDepartment: 'add department',
    departmentName: 'department name',
    superiorDepartment: 'superior department',
    editDepartment: 'edit department',
    departmentTip:
      'Make sure that the deleted department has no members or the department cannot be deleted if there are members',
    confirmDeletion: 'Determine to delete',
    departmentTip2: 'department?',
    departmentTip3:
      'Note: There may be calls to the approval process and custom settings, please adjust the settings before deleting them.',
    pwdType: 'password type',
    SMSpwd: 'SMS password',
    manualInput: 'manual input',
    initializePwd: 'initialize password',
    subordinateDepartment: 'subordinate department',
    mainDepartment: 'main department',
    editMember: 'edit member',
    owner: 'platform owner',
    setPersonCharge: 'Set the person in charge',
    departmentStaff: 'department staff',
    common: 'common',
    activationTip: 'Tip: this action will only send activation reminder SMS to inactive accounts.',
    confirmThe: 'make sure the selected',
    activationTip2: 'Is there an employee account activation reminder?',
    stopUsingTip:
      'Tip: after deactivation, the account cannot be logged into the current platform/organization',
    stopUsingTip2: 'Is this employee account disabled?',
    deleteTip: 'Are you sure to delete the selected account?',
    enableTip: 'Tip: when enabled, it will be assigned to unassigned department staff.',
    enableTip2: 'Is this employee enabled?',
    postManage: 'position management',
    addDuties: 'Add position',
    deleteTip2: 'Note: after deletion, the position will not be restored. Please be careful.',
    deleteTip3: 'Are you sure you want to remove this position?',
    batchImportEmployee: 'Batch import of employees',
    selectFile: 'select file',
    uploadStaff: 'upload staff',
    clickDownload: 'click to download',
    employeeTemplate: 'Employee address book import template',
    templateTip: 'Upload correctly filled employee address book import template',
    matters: 'Matters needing attention',
    matterTip:
      'Be careful not to modify the header name when filling in the information. All items marked as required should be filled in. Allowed to import the document format is: XLS, XLSX; The number of imported bars shall not exceed 1000 and the file size shall not exceed 4M. If you import too much data, the time will be longer, please wait patiently.',
    pwd: 'password',
    department__empty: 'department name cannot be empty',
    departmentLength: 'Department names cannot exceed 25 characters',
    name_empty: 'name cannot be empty',
    role_empty: 'role cannot be empty',
    mianDepartment_empty: 'mian department cannot be empty',
    selectdepartment: 'Please select department',
    noInactiveMembers: 'No inactive member is selected',
    noOperateOwner: 'Cannot operate the platform owner',
    disabledEmployee2: 'disable staff',
    post_empty: 'position cannot be empty',
    uploadFormat_error: 'Upload format error',
    uploadResults: 'upload results ',
    addChildDeppartment: 'add child department',
    editDeppartment: 'edit department',
    deleteDeppartment: 'delete department',

    organizationalstructure: 'organizational structure',
    addressbookisolation: 'Address book isolation',
    character: 'role',
    user: 'user',
    member: 'member',
    activation: 'activation',
    unbindenterprisewechat: 'Untie enterprise wechat',
    synchronousorganizationarchitecture: 'Synchronous organizational structure',
    departmentsettings: 'Department setting',
    unstaple: 'Unbound nails',
    bindcomparisontable: 'Binding cross reference table',
    entrydate: 'Entry date',
    weChataccount: 'Enterprise wechat account',
    accountcorrespondingtable:
      'Corresponding table of enterprise wechat account and this platform account',
    teamfaceaccount: 'This platform account',
    correspondingtableTip:
      'If there is no corresponding member of enterprise wechat, the account will be added to this platform, and the corresponding member will bind the enterprise wechat member to the original account of this platform.',
    unbindenterpriseweChatTip: 'Are you sure you want to unbind the pin',
    unbindenterpriseweChatTip2:
      'After unbinding, the organization structure, members and roles will be allowed to be maintained. To rebind, please set rebinding in [system management];',
    personnelOptionalConfig: 'Personnel optional config',
    personnelOptionalConfigRemark:
      'Configure whether employees can set the order receiving switch. Employees can be selected only after enabling the switch.',
    showReceiveOrderSwitch: 'Show order receiving switch',
    showReceiveOrderSwitchTip:
      'Select "Yes" to show the order receiving switch on the mobile My page',
    forceReceiveOrderSwitch: 'Force order receiving switch on',
    forceReceiveOrderSwitchTip:
      'Select "Yes" to force the order receiving switch on so it cannot be turned off',
    departmentOptionalConfig: 'Department optional config',
    addressbookisolationremark:
      'After setting, the isolated department will be hidden / restricted in the address book. The user-defined module and fixed module are restricted by this setting in the personnel component and department component.',
    quarantinedepartment: 'Quarantine department',
    quarantinedepartmentRaio1: 'Hide the selected department in the address book',
    quarantinedepartmentRaio2:
      'Do you want to restrict the view details of the Department selected above in the address book',
    quarantinedepartmentsettings: 'Isolation department setting',
    addmembersdepartmentsroles: 'Add members, departments, roles',
    quarantinedepartmentRaio3: "Don't hide it",
    quarantinedepartmentRaio4:
      'It is hidden outside the Department, but the person in charge of the Department and the superior department needs to be displayed',
    quarantinedepartmentRaio5: 'Hidden outside the door',
    quarantinedepartmentRaio6: 'Hide from the door and only view yourself',
    quarantinedepartmentRaio7: 'Unlimited',
    quarantinedepartmentRaio8: 'Only members in this department can be viewed',
    quarantinedepartmentRaio9: 'You can only view yourself',
    departmentcannotbeempty: 'Department cannot be empty',
    language: 'language',
    memberexpo: 'Members of the derived',
    // 20210120
    leaderDisplay: 'Person in charge display',
    avatardisplay: 'Head picture display',
    addedSubordinateOrganization: 'New subordinate organization',
    editOrganizationalInformation: 'Edit organization information',
    deletecurrentorganization: 'Delete current organization',
    additionalPersonnel: 'Add personnel',
    relatedStaffDetails: 'Details of associated employees',
    selectatleastonefieldtomatch: 'Select at least one matching field',
    selectamoduleinfor: 'Select a module to display personal information',
    selectmodule: 'Select module',
    selectfieldtomat: 'Select matching fields',
    relatedStaffTip: 'Are you sure you want to clear the details of associated employees?',
    // 20210526
    userNameLeastOneItem: '',
    userNameLeastOneItem2: '',
    emid_error: '',
    // 20220412
    activeemployee: 'Employee',
    inactive: 'Inactive',
    loginprohibited: 'Disable login',
    deactivated: 'Terminated',
    loginprohibitedTip:
      'If checked, it means that the current employee is a virtual account and does not log in to the system, but will participate in business operations such as attendance machine docking, salary calculation, etc.',
    batchSelectTip:
      'You have selected both "enabled" and "disabled" personnel, so batch operations cannot be performed'
  },
  // 角色管理
  role_management: {
    addGroup: 'add group',
    editGroup: 'edit group',
    deleteGroup: 'delete group',
    addRole: 'add role',
    deleteRole: 'delete role',
    editRole: 'edit role',
    editRole2: 'edit role',
    copyRole: 'copy role',
    roleTip:
      'If you want to change the owner of the platform, please go to the 【System Management】 page and click 【Change Owner】 to change the owner. After setting, the information will be automatically synchronized.',
    managemember: 'manage member',
    apply: 'apply',
    module: 'module',
    dataJurisdiction: 'data Jurisdiction',
    funJurisdiction: 'funtion Jurisdiction',
    allSelect: 'Select all',
    oneselfData: 'View personal data only',
    departmentData: 'Check the department data',
    companyData: 'View organization-wide data',
    groupName: 'group name',
    groupDeleteTip: 'Note: this group cannot be recovered after deletion. Please be careful.',
    groupDeleteTip2: 'Are you sure to delete the group?',
    roleName: 'role name',
    roleGroup: 'role group',
    roleGroup2: 'role group',
    describe: 'description',
    roleDeleteTip: 'After deletion, the role cannot be recovered, please exercise caution.',
    roleDeleteTip2: 'Are you sure you want to remove the role?',
    roleDeleteTip3:
      'Note: the approval process and custom settings may be invoked. Please adjust the Settings before deleting.',
    group_empty: 'Role group name cannot be empty!',
    addGroupTip: 'Please create a new group first',
    role_empty: 'Role name cannot be empty!',
    updateTip: 'The content has been updated. Do you need to save it?',

    charactersettings: 'Role setting',
    rolemember: 'Role member',
    businesspermissions: 'Business authority',
    backgroundadministrationauthority: 'Background management authority',
    menuname: 'Menu name',
    permissions: 'jurisdiction'
  },
  // 安全管理
  safe_management: {
    securitysetting: 'security settings',
    pwdPolicy: 'password policy',
    sessionSet: 'session setting',
    dataBackup: 'data backup',
    IPrestriction: 'IP restriction',
    logManage: 'log Management',
    pwdvalidity: 'User password validity ',
    pwdMinLength: 'Minimum password length',
    pwdComplexity: 'password complexity requirements',
    pwdError: 'wrong password',
    enableSMSauthentication: 'Enable SMS verification after',
    lockAccounts: 'Lock the account for 15 minutes after',
    resetPwd: 'Reset the password of all members',
    resetMsg:
      'Check save and let all members of the organization log out from the current login device immediately. After successful login, the password can only be used after mandatory change.',
    saveSet: 'save Settings',
    automaticLogout: 'Automatic logout after a long period of no operation',
    automaticBackup: 'Local automatic backup',
    backupMsg1:
      'Customers can automatically back up local data according to their own data security needs',
    every: 'every',
    backupMsg2:
      'The system automatically backs up at 0 am and only keeps the latest 5 backup files',
    manualBackup: 'Manually triggered backup',
    backupName: 'Backup file name',
    dataReduction: 'Data reduction',
    reductionMsg:
      'If the platform/organization data needs to be restored to the previous content, it can be operated here. Please do not restore the data at will.',
    reduction: 'reduction',
    confirmReduction: 'Confirm the reduction',
    reductionMsg2: 'Manually upload data to restore',
    addAttachment: 'Add attachments',
    dataMigration: 'Cloud data migration',
    migrationMsg1:
      'Migrate the files backed up from the cloud here, and migrate the system from the cloud to the local location.',
    updateFile: 'Upload data file',
    confirmCoverage: 'Confirm the cover',
    cloudBackup: 'cloud backup',
    cloudBackupMsg:
      'Customers can carry out cloud data backup according to their own data security needs. If you need to migrate the cloud data to the local server, please download it, and then re-register in the new server after downloading. Use the organization name and mobile phone number registered in the cloud when registering, and then enter the "data restore" of 【Backend】 -- 【Enterprise Management】 to upload the backup file for restoration',
    reductionTip1: 'Are you sure you want to restore?',
    reductionTip2:
      'Note: after restore, the system will follow the restore file. Please do not operate at will.',
    reductionTip3: 'Do you really want to restore?',
    reductionTip4: 'Please confirm again and restore will be performed after confirmation.',
    backupSuccess:
      'Backup successfully, please go to 【Security Management】 - 【Data Backup】 to obtain',
    ipLimitTip:
      'IP Settings are set for all staff by default, and white-list accounts are not subject to login restrictions:',
    whiteList: 'white List',
    ipLimitTip2:
      'Limit All members of the organization only logged in to the following IP addresses:',
    addIP: 'add IP',
    addIPSegment: 'add IP',
    loginIP: 'login IP',
    addPeople: 'the adding person',
    loginTime: 'login time',
    addLoginIP: 'add login IP',
    ipTip1: 'In order to ensure the platform information more secure',
    ipTip2:
      'To make platform information more secure, platform owners can set logging IP restrictions. After setting, you can only log in under the restricted IP.',
    ipTip3: 'like',
    unlimited: 'unlimited',
    ipLimit1: 'Contains letters and numeric characters',
    ipLimit2: 'Contains letters, numeric characters and special characters',
    ipLimit3: 'Contains Numbers and upper and lower case letters',
    ipLimit4: 'Contains Numbers,  upper and lower case letters and special characters',
    AddressDuplication: 'IP address repetition',
    ipFormatError: 'IP format error',
    ip_empty: 'Setting IP cannot be null',
    backupTip:
      'The backup is possessing, because the backup time is too long, you can finish other work first, and the backup file will be displayed after the backup is completed.',
    backupDay_empty: 'Please enter the backup days',
    backupDayLength: 'Please enter an integer from 1 to 100',
    oneYear: 'one year',
    operationLog: 'operation log',
    loginLog: 'Log-in log',
    operator: 'operator',
    operationTime: 'operation time',

    operationContent: 'Operation content',
    remark: 'remarks',
    createtime: 'Creation time',
    ipstartingaddress: 'IP start address',
    ipendaddress: 'IP end address',
    ipstartingaddresscannotbenull: 'IP start address cannot be empty',
    incorrectipstartaddressformat: 'IP start address format error',
    incorrectipaddressformat: 'IP address format error',
    useractionlog: 'User action log',
    backendoroperationslog: 'Background administrator operation log',
    menu: 'menu',
    behavior: 'behavior',
    username: 'user name',
    androidclient: 'Android client',
    iosclient: 'IOS client',
    windowsclient: 'Windows Clients',
    macclient: 'Mac client',
    ipaddress: 'IP address',
    accountpasswordlogin: 'Account password login',
    mobilephonescancodetologin: 'Mobile phone code scanning login',
    ADdomainLogin: 'AD domain login',
    loginstatus: 'Login status',
    loginsuccessful: 'Login successful',
    loginfailed: 'Login failed',
    ipendaddressformat: 'IP end address format error',
    devicetype: 'Equipment type',
    basic_workbench: 'Basic module - Portal Management',
    basic_project: 'Basic module - collaboration',
    basic_email: 'Basic module - mail',
    basic_approval: 'Basic module - approval',
    basic_filelibrary: 'Basic module - File Library',
    basic_repository: 'Basic module - knowledge base',
    basic_attendance: 'Basic module -attendance',
    basic_salary: 'Basic module - compensation',
    // 20210601
    enableSMSauthentication2: 'enable SMS/email verification after next time'
  },
  // 接口集成
  interface_integration: {
    interface: 'interface',
    serviceInterface: 'interface',
    address: 'address',
    interfaceSpecification: 'interface specification',
    secretKey: 'secret key',
    reset: 'reset',
    pwd: 'password',
    resetTip:
      'Note: Authtoken and API key are important interface call credentials, please pay attention to confidentiality! In case of accidental disclosure, please reset immediately and send the new API key to the interface caller to modify the credentials after reset!',
    customInterface: 'custom interface',
    thirdPartyInterface: 'third party interface',
    pluginDownload: 'Plug-in download',
    downloadPlugin: 'download plug-in',
    useResumeParsingInterface: 'Use the resume parsing interface,please first',
    installPlugIns: 'Install plug-in',
    setRule: 'Setting rules',
    receiveResumeModule: 'receive resume module',
    recognitionField: 'Recognition field',
    moduleField: 'module field',
    valueMapping: 'the mapping value is',
    value: 'the value of',
    tip1: 'One step to import the passive job seekers from major recruitment website and save a series of cumbersome operations.',
    clickHere: '【click here】',
    downloadPluginTip: 'Download the plug-in and follow the steps to install it manually.',
    lunboTip1: '① Unzip the file: download the file and unzip it',
    lunboTip2:
      '② Copy link: using the Chrome browser, copy chrome:\\/\\/extensions and paste it into the address bar, and press enter',
    lunboTip3:
      '③ Drag the folder: drag the unzipped folder to the browser, and the icon will appear in the upper right corner of the browser. Please do not delete or change the path of the folder',
    receivingResume: 'The resume receiving module cannot be empty',
    fieldSet: 'Field Settings cannot be empty',
    dataBase: ' database',
    pleaseConnectToDatabase: 'Please connect to the database first',
    successfulConnection: 'successful Connection',
    unconnected: 'unconnected',
    customModule: 'Custom module',
    databaseForm: 'Database form',
    modifier: 'modifier',
    modificationTime: 'Modify time',
    databaseConnectionSettings: 'Database connection Settings',
    serverAddress: 'Server address',
    portNumber: 'port number',
    databaseBame: ' database name',
    userName: 'user name',
    test: 'test',
    connectionFailed: ' connection fails',
    saveTip: 'can be saved only after connect successully',
    interfaceType: 'interface type',
    changeTime: 'change time',
    ruleCondition: 'Rule and conditions',
    fieldCorrespondence: 'Field correspondence',
    customModuleFields: 'Custom module fields',
    databaseFormFields: 'Database form field',
    beCareful:
      'Please note that the first behavior is a unique constraint ID, which will be used as a condition for judging after data changes.',
    dynamicValue: 'dynamic data',
    fixedValue: 'fixed data',
    deleteTip: 'Are you sure you want to delete this data?',
    readData: 'read data',
    addData: 'add data',
    editData: 'edit data',
    deleteData: 'delete data',
    queryData: 'query data',
    viewDetails: 'view details',
    serverAddress_empty: 'server address cannot be empty',
    portNumber_empty: ' port number cannot be empty',
    portNumber_error: 'Port number format error',
    dataBase_empty: ' database cannot be empty',
    dataBaseNmae_empty: 'database name cannot be empty',
    userName_empty: ' user name cannot be empty',
    databaseForm_empty: 'database form cannot be empty',
    customModule_empty: 'Custom modules cannot be empty',
    constraint_empty: 'constraint cannot be null',
    integrate: 'Set the system interface integration with the third-party platform',
    platform: 'platform name',
    ali: 'Alibaba Cloud',
    UFU8: 'yonyouU8',
    kingdee: 'Kingdee',
    platform_empty: 'platform name cannot be empty',
    method: 'request method',
    fieldName: 'field name',
    fieldID: 'field ID',
    fieldType: 'field type',
    fieldRequired: 'whether required',
    fieldExplain: 'instructions',
    explain: 'request sample ',
    generateSignature: ' generate signature',
    referenceFile: 'Reference file',
    requestEncryption: 'Request encryption',
    local: 'local',
    publicNetwork: 'public Network',
    returnInstructions: ' return to instructions',
    requestFailure: 'request failure',
    requestSuccess: 'request success',
    basicmodule: 'basic module',
    staff: 'staff',
    requestHeader: 'request header',
    requestHeaderParameters: 'request header parameters',
    staffList: 'staff list',
    stafDetail: 'staf detail',
    departmentalList: 'departmental list',
    departmentDetail: 'department detail',
    identityAuthentication: 'identity authentication',
    autograph: 'signature',
    returnType: 'The type of content returned; default',
    option: 'option',

    aliCluster: 'Alicloud integration',
    alitilte: 'AI plug in',
    aliP1:
      'After purchasing the corresponding interface, find the corresponding interface appcode in "cloud market buyer center enter management console".',
    aliAddress: 'Alibaba cloud interface purchase address',
    payaccessto: 'Payment access',
    openTip1:
      'After opening, you can use Alipay payment and use the payment function to open in the custom component number or formula attribute.',
    openTip2:
      'After opening, wechat payment can be used. To use the payment function, please open it in the user-defined component number or formula property.',
    setnow: 'Set now',
    openalipay: 'Alipay',
    openwechatpay: 'Open wechat payment',
    openTip3: 'Please enter Alipay to get corresponding information for configuration.',
    openTip4:
      'Please enter the [wechat background] to obtain the corresponding information for configuration',
    operationmode: 'Operation mode',
    operationmodeTip1:
      'Log in to wechat service number background > wechat payment > Product Center > appid Account Management > appid of service number',
    operationmodeTip2:
      'Log in to wechat service number background > wechat payment > account center > personal information > login account',
    operationmodeTip3:
      'Log in to wechat service number background > wechat payment > account center > API Security > API key',
    alipaypay: 'Alipay payment',
    wechatpay: 'Wechat payment',
    doyouwanttounbind: 'Do you want to untie',
    unbindsuccessfull: 'Unbound successfully',
    getSign: 'Get a signature',
    apiPwd: 'API key',
    sqldocking: 'Enter sql- docking system',
    sqldocking2: 'Enter sql- the system',
    maintableid: 'main table ID',
    usedplugin: 'Plugin used',
    uninstall: 'Uninstall',
    allplugin: ' All plugins',
    downloaded: 'downloaded',
    ssotip: 'Access to other related systems without logging in',
    ssotip2:
      'Through single sign-on,users can log in to other systems with one click in the system workbench,without having to enter the user name/password again',
    resumeanalysistip: 'Use the interface of resume analysis ',
    backtoplugin: 'Back to plugin management',
    systemname: 'system name',
    systemaddress: 'system address',
    systemaddress_empty: 'System address cannot be blank',
    authorizedUser: 'Authorized user',
    authorizedUser_empty: 'Authorized user cannot be blank',
    accountType: 'account Type',
    useTeamfaceaccount: 'use this platform account',
    userentry: 'user entry',
    accountparametername: 'Account parameter name',
    accountparametername_empty: 'Account parameter name cannot be blank',
    passwordparametername: 'Password parameter name',
    passwordparametername_empty: 'Password parameter name cannot be blank',
    putitinmyapplist: 'Add to my application list',
    displayinportalcolumn: 'display in portal column',
    openmode: 'open mode',
    newwindow: 'new window',
    currentworkspace: 'Current workspace',
    otherparameters: 'other parameters',
    addparameters: 'add parameters',
    parametername: 'parameter name',
    parametervalue: 'Parameter value',
    displayposition: 'Display position',
    ssoinfo:
      'Single sign-on (SSO),after users log in to this platform,they can access other related system applications in the system without logging in. That is,they can access other system applications,such as CRM,OA,ERP,etc.,without having to enter the account and password again,reducing login Incurred time consumption and excessive account passwords',
    charge: 'charge',
    pluginintroduce: 'Plug-in introduction',
    // 20210526
    dfmasaf: 'Database form master subtable associated field',
    dfmasaf_empty: 'Database form master subtable associated field cannot be empty',
    timeRepeat: 'The change time cannot be repeated with the change time ',
    miniprogram: 'Miniprogram Business Card',
    miniprogramremark: 'Let customers know us in the first time',
    miniprogramnote:
      'One-stop social marketing platform for social business cards, product Windows, and clue radar',
    isenable: 'Whether to enable',
    bindenterprises: 'Bind organization',
    bindmodule: 'Bind module',
    showCardTip: 'Select or create a module to display visitor information',
    leastOneItem: 'Configure at least the module and one field',
    mapIntegration: 'Map integration',
    bindBaiduAK: 'Bind Baidu AK',
    bindBaiduAKInfo:
      'Use attendance location and custom components. Map components, to bind Baidu map AK, please apply for AK in Baidu map, if there is no binding can not allow map positioning function',
    bindGaoDeAK: 'Bind GaoDe AK',
    bindGaoDeClientAK: 'GaoDe Client AK',
    bindGaoDeSecurity: 'GaoDe Client Secret',
    bindGaoDeAKInfo:
      'Use attendance location and custom components. Map components, to bind GaoDe map AK, please apply for AK in GaoDe map, if there is no binding can not allow map positioning function',
    mapBaidu: 'Baidu map',
    mapGaoDe: 'GaoDe map',
    mapSource: 'Map source'
  },
  // 应用中心
  application_center: {
    recommend: 'recommend',
    industryCategory: 'industry category',
    myUploads: 'my uploads',
    serviceClassification: 'service classification',
    receiptsDetails: 'receipt details',
    appIcon: 'application Icon',
    appName: 'application Name',
    price: 'price',
    free: 'free',
    pay: 'pay',
    uploader: 'uploader',
    updataTime: 'updata time',
    state: 'statue',
    yobeAudited: 'wait for approval',
    notpass: 'not pass',
    havePassed: 'passed',
    operation: 'have passed',
    details: 'details',
    auditOpinion: 'Audit opinion',
    msg1: 'Are you sure you want to delete the application?',
    msg2: 'This operation will only be removed from the "my upload" list and will not affect the application\'s use in other modules.',
    totalSum: 'total sum',
    auditAmount: 'audit amount',
    arrivalAccount: 'arrival account',
    downNum: 'download number',
    msg3: 'Sorry that the application you uploaded failed to pass the audit.',
    msg4: 'You may try to adjust your application to the following (including but not limited to) modification comments for resubmission to review.',
    team: 'team',
    auditIn: 'audit in',

    industry: 'industry',
    install: 'install',
    alreadyInstall: 'installed',
    onTrial: 'on trial',
    classify: 'classify',
    price2: 'price',
    developer: 'developer',
    installNum: 'install number',
    second: 'times',
    score: 'score',
    moduleIntroduction: 'module introduction',
    moduleScreenshots: 'module screenshots',
    sweepingPayment: 'scan and pay',
    wechatpay: 'open "Wechat Scan" mobile and can the QR code to complete payment',
    aliipay: 'open Alipay mobile and scan the QR code to complete payment',
    paymenCompleted: 'paymen completed',
    installSuccess: 'install successfully',
    sweepCodePayment: 'Please scan the QR code to pay first ',

    sizeInfo: '10 pieces/page',
    expandMore: 'show more',
    star: 'Star ratings',
    star_empty: 'Star ratings cannot be empty',
    comment_empty: 'Comments cannot be empty',
    send: 'send',
    installation:
      'The application is being installed,please check it in the custom application list later',
    cost: 'cost',
    customization: 'custom made',
    // 20220412
    iwantconsult: 'I want to consult',
    scanningcodeconsultcustomerservice: 'WeChat scan code to consult professional customer service',
    experience: 'Experience',
    startapplication: 'Start this app',
    version: 'Version',
    customizedscenesystem:
      'According to the needs of the user itself, customize the application system that meets the use of business scenarios',
    Customizenow: 'Customize now',
    installingapp: 'Installing app',
    contactadministratorinstall: 'lease contact your system administrator to install',
    industrySolutions: 'Industry Solutions'
  },
  // 回收站
  recycle_bin: {
    module: 'module',
    deletePerson: 'deleting person',
    deleteTime: 'deleting time',
    reduction: 'restore',
    emptyTrash: 'empty the recycle bin',
    msg1: 'Are you sure to restore data to before deleting?',
    msg2: 'Are you sure you want to delete the data?',
    msg3: 'Are you sure you want to empty the recycle bin?',
    msg4: 'When deleted, the data will not be recoverable',
    msg5: 'When emptied, the data will not be recoverable',
    // 20220412
    hardDelete: 'hard delete'
  },
  // 自动化任务监控
  task_monitoring: {
    selectForm: 'Select Form',
    selectFormPlaceholder: 'Please select a form',
    customNumber: 'Custom Number',
    customNumberPlaceholder: 'Please enter a custom number',
    ruleTitle: 'Rule Name',
    ruleTitlePlaceholder: 'Please enter the rule name',
    executeStatus: 'Execution Status',
    executeStatusPlaceholder: 'Please select the execution status',
    executeStatusSucc: 'Execution Successful',
    executeStatusFail: 'Execution Failed',
    serialNumber: 'Serial Number',
    taskID: 'Task ID',
    moduleName: 'Form Name',
    ruleTriggers: 'Trigger Events',
    ruleRemark: 'Rule Description',
    taskStartTime: 'Task Start Time',
    taskExecutionRecord: 'Task Execution Record',
    nameOfTheExecutedOperation: 'Name of Executed Operation',
    operationDetail: 'Operation Details',
    operationName: 'Operation Name'
  },
  // 个人设置
  personal_setting: {
    basicSetup: 'basic setup',
    updatePwd: 'update password',
    oldPwd: 'original password',
    newPwd: 'new password',
    updateInfo:
      'You\'ll need to enter your current password when you change your password, and if you forget your current password, you can reset your password through the "Forgot Password" feature in the login interface.',
    modifyPhone: 'modify phone number',
    currentmobile: 'Your current mobile phone number is',
    updatePhoneMsg:
      'When you modify your phone number, the system will send a verification code to a new mobile phone number.Enter the verification code to complete the modification.',
    updatePhoneMsg2:
      "Mobile phone number is not only personal communication mode, but also the system's login account.If it is not to replace the mobile phone, it is recommended not to change the mobile phone number at will so that avoid forgetting to log in to the account.",
    newNumber: 'Enter a new mobile phone number',
    phoneCode: 'Enter your verification code from your phone received',
    getcode: 'Get a verification code',
    exitSession: 'exit sessions ',
    exitMsg:
      'If your phone is missing, to prevent others from seeing your information, you can exit all sessions except your current browser from here.',
    headSculpture: 'Set up your head photo',
    headSculptureMsg:
      'You can replace your picture, the picture will automatically generate three sizes, please note that the changed picture is clear.',
    selectPhotos: 'Select photo upload',
    photoMsg: 'only support JPG, GIF, PNG formatand files less than 3M ',
    personal: 'personal information',
    personalMsg:
      'Manage your personal information and update your name, gender, birthday, and more',
    updatePhotos: 'upload head photo',
    phoneCode_empty: ' phone verification code cannot be empty',
    codehasbeensent: 'The verification code has been sent to this phone number',
    retrieve: 'retrieve after',
    name_empty: 'Name cannot be empty',
    pwdDifferent: 'new password is not the same as the confirmation password',
    photoError: 'Please upload a picture in JPG, GIF, PNG format',
    filesize: 'File larger than 3M',
    oldPwd_empty: 'original password cannot be empty',

    basicInfo: 'Basic information',
    thirdpartydataimprovement: 'Third party binding integration data improvement',
    perfectTip:
      'This setting is only displayed when the pin or enterprise wechat integration mode and the mobile phone number is not entered. After the mobile phone number and login password are supplemented, users of binding nail and enterprise wechat can log in through mobile number + password.',
    suretomodify:
      'The current mobile phone number exists in another organization. Are you sure you want to modify it'
  },
  // 平台模版
  platform_template: {}
}
